import axios from "axios";
import { VIEW } from "../mutation-types"
const state = {
    viewData: {
    },
}

const getters = {
    viewData: state => key => {
        return state.viewData[key]
    }
}

const actions = {
    setViewData ({ commit }, viewData){
        commit(VIEW.SET_DATA, viewData)
    },
}

const mutations = {
    [VIEW.SET_DATA] (state, viewData){
        state.viewData[viewData.viewId] = viewData.viewData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
